import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

type DefaultPageHeaderSubtitleProps = StylableComponent<HTMLDivElement> & {
  subtitle?: ReactNode;
  isCollapsed?: boolean;
};

const DefaultPageHeaderSubtitle: FC<DefaultPageHeaderSubtitleProps> = ({
  subtitle,
  isCollapsed,
  style,
  ...props
}) => (
  <div
    {...props}
    css={[
      isCollapsed ? theme.typography.bodyMedium : theme.typography.heading2,
      {
        transition: theme.transitions.create('font-size'),
        paddingBottom: isCollapsed ? 9 : 29,
        color: theme.colors.charcoal700,
      },
      style,
    ]}
  >
    {subtitle}
  </div>
);

DefaultPageHeaderSubtitle.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Page subtitle */
  subtitle: PropTypes.string,
};

export default DefaultPageHeaderSubtitle;
